import axios from 'axios';
import { t } from 'i18next';
import { endpoints } from '../../utils/constants';

const getOrder = (probillNumber, updateState, accountNumbers) =>
  axios.get(`${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.manageOrders.trackOrderById}`, {
    params: { probillNumber },
    headers: { accountNumbers },
  }).then((res) => {
    if (res.status === 200) {
      updateState('data', res.data);
    }
  });

export default getOrder;
